import { Box, Grid, Typography } from "@mui/material";
import { guestMachines, userMachines } from "api/machines";
import { useUserContext } from "context/userContext";
import React, { useEffect, useState } from "react";
import { useCart } from "../../context/CartContext";
import PaginationControl from "../PaginationControl";
import { MachineCard, Machines } from "./Machines";

const MachinesDataCards = ({
  machineSearch,
  typeSearch,
  isLoading,
  setIsLoading,
}) => {
  const { updateItemQuantity, addToCart } = useCart();

  const [machinesList, setMachinesList] = useState([]);
  const [expanded, setExpanded] = useState("");
  const [quantity, setQuantity] = useState({});
  const [page, setPage] = useState(1);
  const [itemsPerPage] = useState(15);
  const { isAuth } = useUserContext();

  useEffect(() => {
    if (!machineSearch) return;

    const controller = new AbortController();

    const fetchData = async () => {
      setIsLoading(true);
      try {
        let response;
        if (isAuth) {
          response = await userMachines(
            machineSearch,
            typeSearch,
            controller.signal
          );
        } else {
          response = await guestMachines(
            machineSearch,
            typeSearch,
            controller.signal
          );
        }

        if (Array.isArray(response.data.data)) {
          setMachinesList(response.data.data);
        } else if (response.data && typeof response.data === "object") {
          setMachinesList(response.data.data.products || []);
        } else {
          setMachinesList([]);
        }
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setMachinesList([]);
        setIsLoading(false);
      }
    };

    fetchData();

    return () => {
      controller.abort();
    };
  }, [machineSearch, typeSearch, isAuth]);

  const pageCount = Math.ceil(machinesList.length / itemsPerPage);
  const paginatedData = machinesList.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleQuantityChange = async (itemId, newQuantity) => {
    try {
      updateItemQuantity(itemId, newQuantity);
    } catch (error) {
      console.error("Failed to update quantity", error.message);
    }
  };

  const handleAddToCart = (item) => {
    const numberOfItems = quantity[item.id] || 1;
    addToCart(item, numberOfItems);
  };

  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    !isLoading &&
    paginatedData && (
      <>
        <Grid container spacing={3} mt={0} mb={5}>
          {paginatedData.length > 0 ? (
            paginatedData.map((item) => {
              return (
                <Grid item xs={12} sm={6} md={4} key={item.id}>
                  {isAuth ? (
                    <MachineCard
                      expanded={expanded}
                      handleAccordionChange={handleAccordionChange}
                      item={item}
                      quantity={quantity}
                      handleQuantityChange={handleQuantityChange}
                      handleAddToCart={handleAddToCart}
                    />
                  ) : (
                    <Machines
                      machine={item}
                      handleAddToCart={handleAddToCart}
                    />
                  )}
                </Grid>
              );
            })
          ) : (
            <Grid item xs={12}>
              <Box textAlign="center">
                <Typography variant="h6">Ingen data fundet</Typography>
              </Box>
            </Grid>
          )}
        </Grid>
        {machinesList.length > itemsPerPage && (
          <PaginationControl
            pageCount={pageCount}
            page={page}
            handlePageChange={handlePageChange}
          />
        )}
      </>
    )
  );
};

export default MachinesDataCards;
